import Component from '../core/Component'
import scrollToElement from '../services/Viewport/scrollToElement'

export default class Link extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()

        let url     = event.target.closest('a').getAttribute('href')
        let target  = document.getElementById(url.substr(url.indexOf('#','')+1))
        scrollToElement(target)
    }
}